import L from 'leaflet';

L.Popup.include({
    _updateContent() {
        if (!this._content) { return; }

        const node = this._contentNode;
        const content = (typeof this._content === 'function') ? this._content(this._source || this) : this._content;

        if (!content) {
            this._container.style.display = 'none';
            return;
        }
        this._container.style.display = 'block';

        if (typeof content === 'string') {
            node.innerHTML = content;
        } else {
            while (node.hasChildNodes()) {
                node.removeChild(node.firstChild);
            }
            node.appendChild(content);
        }
        this.fire('contentupdate');
    },
});
